import { AssignedExperimentBucket } from '../experiments.types'

// This generated cookie string that encapsulate experiment bucket information of user to be
// persisted in cookies for later access.
export const generateCookieStringForExperimentBucket = (experimentBucketRows: AssignedExperimentBucket[]) =>
  experimentBucketRows
    .map(({ name, date, bucket, expiryTime }) => `${name}_${date}_${bucket}_${expiryTime}`)
    .join('___')

export const getExperimentDetailsFromCookieString = (expBucketString: string) => {
  const expBucketSplit = expBucketString.split('_')
  const expiryTime = expBucketSplit.pop()
  const expBucket = expBucketSplit.pop()
  const expDate = expBucketSplit.pop()
  const expName = expBucketSplit.join('_')
  return {
    expName,
    expDate,
    expBucket,
    expiryTime,
  }
}
